import React from 'react';
import { X, ShieldCheck, ShoppingBag, MessageCircle } from 'lucide-react';

interface CustomerTermsModalProps {
    isOpen: boolean;
    onClose: () => void;
    storeName?: string;
}

const CustomerTermsModal: React.FC<CustomerTermsModalProps> = ({ isOpen, onClose, storeName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl relative overflow-hidden flex flex-col max-h-[85vh]">
                {/* Header */}
                <div className="p-6 border-b border-surface-100 flex justify-between items-center bg-surface-50">
                    <div className="flex items-center gap-3 font-black text-surface-900">
                        <ShieldCheck size={20} className="text-brand-600" />
                        <span className="text-sm uppercase tracking-widest">Termos & Privacidade</span>
                    </div>
                    <button onClick={onClose} className="p-1 hover:bg-surface-200 rounded-full transition-colors">
                        <X size={20} className="text-surface-400" />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-6 md:p-8 space-y-6 text-sm text-surface-600 leading-relaxed font-medium">
                    <section>
                        <h4 className="font-black text-surface-900 mb-2 flex items-center gap-2">
                            <ShieldCheck size={16} className="text-brand-600" /> 1. Aviso de Privacidade (LGPD)
                        </h4>
                        <p>
                            Ao utilizar esta vitrine eletrônica para iniciar um pedido, a loja <strong>{storeName || 'esta loja'}</strong> atua como a <strong>Controladora</strong> dos seus dados pessoais básicos (nome e telefone), necessários exclusivamente para o processamento do pedido e contato via WhatsApp.
                        </p>
                        <p className="mt-2">
                            Nós não compartilhamos seus dados com terceiros, exceto para o envio da mensagem ao WhatsApp do lojista.
                        </p>
                    </section>

                    <section>
                        <h4 className="font-black text-surface-900 mb-2 flex items-center gap-2">
                            <ShoppingBag size={16} /> 2. Vendas e Responsabilidades
                        </h4>
                        <p>
                            A <strong>ZapShop</strong> é uma plataforma tecnológica intermediadora.
                            Todas as transações, estoques, preços e entregas são de inteira responsabilidade da loja <strong>{storeName || 'esta loja'}</strong>.
                        </p>
                    </section>

                    <section>
                        <h4 className="font-black text-surface-900 mb-2 flex items-center gap-2">
                            <MessageCircle size={16} /> 3. Intermediação Conversacional
                        </h4>
                        <p>
                            O sistema fornece apenas a interface de catálogo. O fechamento e pagamento do pedido ocorrem de forma direta com o lojista. A ZapShop não armazena dados de pagamento sensíveis.
                        </p>
                    </section>

                    <section className="bg-amber-50 p-4 rounded-2xl border border-amber-100 text-amber-800 text-[11px] leading-tight">
                        <p>
                            <strong>Isenção de Responsabilidade do Desenvolvedor:</strong> O proprietário da infraestrutura (Vinícius Alves Gonçalves de Matos) não possui qualquer responsabilidade sobre desvios financeiros ou danos na relação comercial entre cliente e lojista.
                        </p>
                    </section>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-surface-100 bg-surface-50">
                    <button
                        onClick={onClose}
                        className="w-full bg-brand-600 hover:bg-brand-700 text-white font-black py-3 rounded-2xl transition-all shadow-lg shadow-brand-600/20"
                    >
                        Entendi e Desejo Continuar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomerTermsModal;
